import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useMsal } from '@azure/msal-react';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const {accounts} = useMsal();
  return (
    <Route
      {...rest}
      render={(props) =>
        accounts.length > 0 ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default ProtectedRoute;
